import { Box, CircularProgress } from "@mui/material";
import React from "react";

const Loader = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          bgcolor: "transparent",
          zIndex: 9999,
        }}
      >
        <CircularProgress />
      </Box>
    </>
  );
};

export default Loader;
